import { API } from "@/main.js";

const state = {
  simulationList: {},
  dataToSend: {
    workspaceGeomatry: null,
    workspace: null,
    selectedBuildings: [],
    projection: 3857,
    percentages: ['', '', '', '', '100']
  },
  provisionalWorkspaceId: null,
  simulationConfiguration: {code: 'Atesio', description: 'test'},
};

const getters = {
  getWorkspaceGeometry: (state) => state.dataToSend.workspaceGeomatry,
  getWorkspace: (state) => state.dataToSend.workspace,
  getSelectedBuildings: (state) => state.dataToSend.selectedBuildings,
  getProjection: (state) => state.dataToSend.projection,
  getSimulationConfiguration: (state) => state.simulationConfiguration,
  getProvisionalWorkspace: (state) => state.provisionalWorkspaceId,
  getPercentages: (state) => state.dataToSend.percentages
};

const mutations = {
  CLEAR_SIMULATION_CONFIGURATION(state) {
    state.simulationConfiguration = {}
  },
  SET_SIMULATION_CONFIGURATION(state, forms) {
    state.simulationConfiguration = {...state.simulationConfiguration, forms};
  },
  SET_PROVISIONAL_WORKSPACE(state, id) {
    state.provisionalWorkspaceId = id;
  },
  SET_WORKSPACE_GEOMETRY(state, geometry) {
    state.dataToSend.workspaceGeomatry = geometry;
  },
  ADD_BUILDING(state, building) {
    state.dataToSend.selectedBuildings.push(building);
  },
  EDIT_PERCENTAGE(state, obj) {
    state.dataToSend.percentages[obj.index] = obj.value;
  },
  CLEAR_PERCENTAGE(state) {
    state.dataToSend.percentages = [];
  },
  DELETE_BUILDING(state, buildingId) {
    const index = state.dataToSend.selectedBuildings.findIndex(
      (building) => building.bd_id === buildingId
    );
    if (index !== -1) {
      state.dataToSend.selectedBuildings.splice(index, 1);
    }
  },
  SET_WORKSPACE(state, workspace) {
    state.dataToSend.workspace = workspace;
  },
  SET_PROJECTION(state, projection) {
    state.dataToSend.projection = projection;
  },
  CLEAR_WORKSPACE(state) {
    state.dataToSend.workspace = null;
  },
  CLEAR_WORKSPACE_GEOMETRY(state) {
    state.dataToSend.workspaceGeomatry = null;
  },
  CLEAR_BUILDINGS(state) {
    state.dataToSend.selectedBuildings = [];
  },
};

const actions = {
  editPercentage({commit}, obj) {
    commit("EDIT_PERCENTAGE", obj)
  },
  setProvisionalWorkspace({commit}, id) {
    commit("SET_PROVISIONAL_WORKSPACE", id)
  },
  clearPercentage({commit}) {
    commit("CLEAR_PERCENTAGE")
  },
  clearSimulationConfiguration({commit}) {
    commit("CLEAR_SIMULATION_CONFIGURATION")
  },
  setSimulationConfiguration({commit}, forms) {
    commit("SET_SIMULATION_CONFIGURATION", forms)
  },
  setWorkspaceGeomatry({ commit }, geometry) {
    commit("SET_WORKSPACE_GEOMETRY", geometry);
  },
  setWorkspace({ commit }, workspace) {
    commit("SET_WORKSPACE", workspace);
  },
  setProjection({ commit }, projection) {
    commit("SET_PROJECTION", projection);
  },
  addBuilding({ commit }, building) {
    commit("ADD_BUILDING", building);
  },
  deleteBuilding({ commit }, buildingId) {
    commit("DELETE_BUILDING", buildingId);
  },
  clearBuildings({ commit }) {
    commit("CLEAR_BUILDINGS");
  },
  clearWorkspace({ commit }) {
    commit("CLEAR_WORKSPACE");
  },
  clearWorkspaceGeometry({ commit }) {
    commit("CLEAR_WORKSPACE_GEOMETRY");
  },
  GET_SIMULATIONS: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      API.simulations.getAllSimulations(
        (result) => {
          const data = result.data.data;
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
  CREATE_SIMULATION_CONFIG: ({ commit}, data) => {
    return new Promise((resolve, reject) => {
      API.simulations.createSimulationConfig(
        data,
        (result) => {
          resolve(result.data.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
  CREATE_SIMULATION: ({ commit}, data) => {
    return new Promise((resolve, reject) => {
      API.simulations.createSimulation(
        data,
        (result) => {
          resolve(result.data.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
  GET_SIMULATION_FORMS: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      API.simulations.getConfigurationForms(
        (result) => {
          const data = result.data.data;
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
  GET_WORKSPACES_SIMUALTION:({ commit}, simulationUuid) => {
    return new Promise((resolve, reject) => {
      API.simulations.getWorkspacesSimulation(
        simulationUuid,
        (result) => {
          resolve(result.data.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  GET_ALL_BUILDINGS_NPV(
    { commit, state },
    { polygon = null, projection = null }
  ) {
    return new Promise((resolve, reject) => {
      API.networkObject.getAllWithinPolygon(
        "buildings",
        null,
        null,
        null,
        "coordinates",
        false,
        polygon,
        projection,
        true,
        (result) => {
          resolve(result.data.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  GET_SIMULATIONS_UUID: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.simulations.getSimulationById(
        uuid,
        (result) => {
          const data = result.data.data;
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  GET_BUILDINGS_UUID: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.simulations.getBuildings(
        uuid,
        (result) => {
          const data = result.data.data;
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  GET_PATHWAYS_UUID: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.simulations.getPathways(
        uuid,
        (result) => {
          const data = result.data.data;
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
  GET_SIMULATIONS_REPORT: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.simulations.getSimulationReport(
        uuid,
        (result) => {
          resolve(result.data.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  GET_SIMULATIONS_REPORT_UUID: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.simulations.getSimulationDetails(
        uuid,
        (result) => {
          const data = result.data.data;
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  GET_LIST_FILTERED: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.getByType(
        data.listName,
        data.listFilters,
        (result) => {
          let list = result.data.data[data.listName];
          resolve(list);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  UPDATE_LIST: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.editList(
        data.uuid,
        data.listValueData,
        (result) => {
          dispatch("GET_LIST_OF_LISTS");
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  CREATE_NEW_LIST_ITEM: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.createListItem(
        data.listName,
        data.listValueData,
        (result) => {
          dispatch("GET_LIST", { listName: data.listName });
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  UPDATE_LIST_ITEM: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.editListItem(
        data.listName,
        data.itemCode,
        data.listValueData,
        (result) => {
          dispatch("GET_LIST", { listName: data.listName });
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  DELETE_LIST_ITEM: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.deleteListItem(
        data.listName,
        data.itemCode,
        (result) => {
          dispatch("GET_LIST", { listName: data.listName });
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
  DELETE_SIMULATIONS: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.simulations.deleteSimulation(
        uuid,
        (result) => {
          resolve(result.data.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/simulations.js